"use strict";

exports.__esModule = true;
exports.createSubscription = createSubscription;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * React 18-compatible replacement for the `create-subscription` package.
 * Same config shape, `{ getCurrentValue, subscribe }` → render-prop component,
 * but not the same contract: whatever a `subscribe` implementation passes to
 * its listener, value or error, is ignored. Every notification re-reads
 * `getCurrentValue(source)`, so the source itself must hold the latest value
 * (the realtime cache does; a push-only source has to store what it pushes).
 *
 * useSyncExternalStore requires getSnapshot to return a referentially stable
 * value when the store has not changed; otherwise React re-renders forever.
 * Callers often normalize cache hits into new object identities, so we memoize
 * the last snapshot with a deep equality check.
 */
function createSubscription(_ref) {
  var getCurrentValue = _ref.getCurrentValue,
    subscribe = _ref.subscribe;
  function Subscription(_ref2) {
    var source = _ref2.source,
      children = _ref2.children;
    var sourceRef = (0, _react.useRef)(source);
    sourceRef.current = source;
    var snapshotRef = (0, _react.useRef)(undefined);
    var hasSnapshotRef = (0, _react.useRef)(false);
    var subscribeToStore = (0, _react.useCallback)(function (onStoreChange) {
      // useSyncExternalStore's listener must be called with no meaningful args
      return subscribe(sourceRef.current, function () {
        onStoreChange();
      });
    },
    // Re-subscribe when source identity changes (callers rebuild state on param changes).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [source]);
    var getSnapshot = (0, _react.useCallback)(function () {
      var next = getCurrentValue(sourceRef.current);
      if (hasSnapshotRef.current && (0, _reactFastCompare["default"])(snapshotRef.current, next)) {
        return snapshotRef.current;
      }
      snapshotRef.current = next;
      hasSnapshotRef.current = true;
      return next;
    }, [source]);
    var value = (0, _react.useSyncExternalStore)(subscribeToStore, getSnapshot, getSnapshot);
    if (typeof children === "function") {
      return children(value);
    }
    return children;
  }
  Subscription.displayName = "Subscription";
  return Subscription;
}